module.exports = __webpack_public_path__ + "c4385f6bfcce46a412c5f09c9e7312b8.pdf";